import { EXPIRY_STATE, getExpiryMeta } from "./expiry";

// Colour is never the only signal: the label itself says "Today",
// "3 days" or "Expired 2 days ago".
const TONES = {
  [EXPIRY_STATE.TODAY]: { background: "#dc2626", color: "#ffffff", pill: true, weight: 700 },
  [EXPIRY_STATE.SOON]: { background: "#fef3c7", color: "#92400e", pill: true, weight: 600 },
  [EXPIRY_STATE.EXPIRED]: { background: "transparent", color: "#b91c1c", pill: false, weight: 600 },
  [EXPIRY_STATE.OK]: { background: "transparent", color: "#374151", pill: false, weight: 500 },
  [EXPIRY_STATE.NONE]: { background: "transparent", color: "#6b7280", pill: false, weight: 500 },
};

const TITLES = {
  [EXPIRY_STATE.TODAY]: "Expires today",
  [EXPIRY_STATE.SOON]: "Expires within 7 days",
  [EXPIRY_STATE.EXPIRED]: "This document has expired",
  [EXPIRY_STATE.OK]: "",
  [EXPIRY_STATE.NONE]: "No expiry date recorded",
};

const ExpiryBadge = ({ document, size = "sm" }) => {
  const meta = getExpiryMeta(document);
  const tone = TONES[meta.state];

  return (
    <span
      title={TITLES[meta.state] || undefined}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        padding: tone.pill ? "2px 9px" : 0,
        borderRadius: "999px",
        fontSize: size === "lg" ? "14px" : "12px",
        fontWeight: tone.weight,
        lineHeight: 1.6,
        whiteSpace: "nowrap",
        background: tone.background,
        color: tone.color,
      }}
    >
      {meta.state === EXPIRY_STATE.TODAY && (
        <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" style={{ fontSize: "10px" }} />
      )}
      {meta.label}
    </span>
  );
};

export default ExpiryBadge;
